module.exports = __webpack_public_path__ + "img/1.68ced5fe.jpg";